// extracted by mini-css-extract-plugin
export default {"days":"_2Bsea","day":"RyE4P","empty":"Odxp9"};